var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 24.5002H16.3333C16.3333 25.7835 15.2833 26.8335 14 26.8335C12.7167 26.8335 11.6667 25.7835 11.6667 24.5002ZM24.5 22.1668V23.3335H3.5V22.1668L5.83333 19.8335V12.8335C5.83333 9.21683 8.16667 6.06683 11.6667 5.01683V4.66683C11.6667 3.3835 12.7167 2.3335 14 2.3335C15.2833 2.3335 16.3333 3.3835 16.3333 4.66683V5.01683C19.8333 6.06683 22.1667 9.21683 22.1667 12.8335V19.8335L24.5 22.1668ZM19.8333 12.8335C19.8333 9.56683 17.2667 7.00016 14 7.00016C10.7333 7.00016 8.16667 9.56683 8.16667 12.8335V21.0002H19.8333V12.8335Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackBell);
export default __webpack_public_path__ + "static/media/black_bell.cb970ea7a4efeb15a05f7bd0881c82f8.svg";
export { ForwardRef as ReactComponent };